import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { Plus, Pencil, Trash2, X, Save } from 'lucide-react';

export default function TiposCliente() {
  const [tipos, setTipos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ nome: '', is_padrao: false, is_ativo: true, desconto_percentual: 0 });
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const load = () => api.get('/configuracoes/tipos-cliente').then(r => setTipos(r.data)).catch(() => {}).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const openNew = () => { setForm({ nome: '', is_padrao: false, is_ativo: true, desconto_percentual: 0 }); setEditId(null); setShowForm(true); setError(''); };
  const openEdit = (t) => { setForm({ nome: t.nome, is_padrao: t.is_padrao, is_ativo: t.is_ativo, desconto_percentual: t.desconto_percentual || 0 }); setEditId(t.id); setShowForm(true); setError(''); };

  const handleSave = async () => {
    if (!form.nome) { setError('Nome é obrigatório'); return; }
    setSaving(true);
    try {
      if (editId) await api.put(`/configuracoes/tipos-cliente/${editId}`, form);
      else await api.post('/configuracoes/tipos-cliente', form);
      setShowForm(false);
      setLoading(true);
      load();
    } catch (err) { setError(err.userMessage || 'Erro ao salvar'); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Excluir este tipo?')) return;
    try {
      await api.delete(`/configuracoes/tipos-cliente/${id}`);
      setTipos(ts => ts.filter(t => t.id !== id));
    } catch (err) { alert(err.userMessage || 'Erro ao excluir'); }
  };

  return (
    <div data-testid="tipos-cliente">
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="dashboard-heading text-2xl">Tipos de Cliente</h1><p className="text-brand-text-muted font-body text-sm">Definem a tabela de preços para cada cliente</p></div>
        <button onClick={openNew} className="flex items-center gap-2 py-2 px-4 rounded-lg btn-primary font-dashboard font-semibold text-sm" data-testid="new-tipo-btn"><Plus className="w-4 h-4" /> Novo Tipo</button>
      </div>

      {showForm && (
        <div className="card-dashboard mb-4 max-w-md">
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-dashboard font-semibold text-brand-text">{editId ? 'Editar' : 'Novo'} Tipo de Cliente</h3>
            <button onClick={() => setShowForm(false)}><X className="w-4 h-4 text-brand-text-muted" /></button>
          </div>
          {error && <p className="text-red-600 text-sm mb-3">{error}</p>}
          <div className="space-y-3">
            <div><label className="block text-xs text-brand-text-muted mb-1 font-body">Nome *</label>
              <input className="w-full rounded-lg border border-brand-border px-3 py-2 text-sm font-body focus:outline-none focus:ring-2 focus:ring-brand-accent-mid" value={form.nome} onChange={e => setForm(f => ({ ...f, nome: e.target.value }))} placeholder="Ex: Varejo, Atacado, Parceiro..." data-testid="field-nome-tipo" />
            </div>
            <div><label className="block text-xs text-brand-text-muted mb-1 font-body">Desconto (%)</label>
              <div className="relative">
                <input
                  type="number" min="0" max="100" step="0.5"
                  className="w-full rounded-lg border border-brand-border px-3 py-2 pr-8 text-sm font-body focus:outline-none focus:ring-2 focus:ring-brand-accent-mid"
                  value={form.desconto_percentual}
                  onChange={e => setForm(f => ({ ...f, desconto_percentual: parseFloat(e.target.value) || 0 }))}
                  placeholder="0"
                  data-testid="field-desconto"
                />
                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-brand-text-muted">%</span>
              </div>
            </div>
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" checked={form.is_padrao} onChange={e => setForm(f => ({ ...f, is_padrao: e.target.checked }))} />
              <span className="text-sm font-body text-brand-text">Tipo padrão (usado na importação XLSX)</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" checked={form.is_ativo} onChange={e => setForm(f => ({ ...f, is_ativo: e.target.checked }))} />
              <span className="text-sm font-body text-brand-text">Ativo</span>
            </label>
            <button onClick={handleSave} disabled={saving} className="flex items-center gap-2 px-4 py-2.5 rounded-lg btn-primary font-dashboard font-semibold text-sm" data-testid="save-tipo-btn">
              <Save className="w-4 h-4" /> {saving ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </div>
      )}

      <div className="card-dashboard">
        {loading ? <div className="flex justify-center py-12"><div className="w-6 h-6 border-4 border-brand-primary border-t-transparent rounded-full animate-spin" /></div> :
          tipos.length === 0 ? <p className="text-center text-brand-text-muted text-sm py-12 font-body">Nenhum tipo cadastrado</p> : (
          <table className="w-full text-sm font-body">
            <thead><tr className="border-b border-brand-border bg-brand-bg">
              <th className="text-left py-2.5 px-3 text-xs text-brand-text-muted font-dashboard">Nome</th>
              <th className="text-center py-2.5 px-3 text-xs text-brand-text-muted font-dashboard">Desconto</th>
              <th className="text-center py-2.5 px-3 text-xs text-brand-text-muted font-dashboard">Padrão</th>
              <th className="text-center py-2.5 px-3 text-xs text-brand-text-muted font-dashboard">Status</th>
              <th className="py-2.5 px-3"></th>
            </tr></thead>
            <tbody>
              {tipos.map(t => (
                <tr key={t.id} className="border-b border-brand-border last:border-0 hover:bg-brand-bg/50" data-testid="tipo-row">
                  <td className="py-2.5 px-3 font-medium text-brand-text">{t.nome}</td>
                  <td className="py-2.5 px-3 text-center">
                    {t.desconto_percentual > 0
                      ? <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full font-semibold">{t.desconto_percentual}%</span>
                      : <span className="text-xs text-brand-text-muted">–</span>}
                  </td>
                  <td className="py-2.5 px-3 text-center">{t.is_padrao ? <span className="text-xs bg-brand-accent-light text-brand-dark px-2 py-0.5 rounded-full font-medium">Padrão</span> : '–'}</td>
                  <td className="py-2.5 px-3 text-center"><span className={`text-xs px-2 py-0.5 rounded-full font-medium ${t.is_ativo ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>{t.is_ativo ? 'Ativo' : 'Inativo'}</span></td>
                  <td className="py-2.5 px-3">
                    <div className="flex gap-2 justify-end">
                      <button onClick={() => openEdit(t)} className="p-1.5 rounded hover:bg-brand-bg" data-testid="edit-tipo-btn"><Pencil className="w-3.5 h-3.5 text-brand-text-muted" /></button>
                      <button onClick={() => handleDelete(t.id)} className="p-1.5 rounded hover:bg-red-50" data-testid="delete-tipo-btn"><Trash2 className="w-3.5 h-3.5 text-red-500" /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
